module.exports = {

  existElement: function(el) {
    return el.length;
  },

  fileReader: function(widgetId) {
    var widget = $('#ci-widget-' + widgetId);
    var image = $('.widget-id-' + widgetId).find('img[data-type="image"]');
    var fileName = localStorage.getItem('file_name_' + widgetId);

    /**
     * Verifica se l'immagine è già presente nella preview del widget
     */
    function imagePreviewExist() {
      if(image.length > 0 && fileName == null) {
        fileName = image.attr('src').split('/')[2];
      }

      if(fileName != null) {
        return fileName;
      }

      return fileName;
    }

    /**
     * Scrive il nome dell'immagine nella modale
     */
    widget
      .find('.ci-widget__file-name')
      .text(imagePreviewExist());

    /**
     * Change sul file input del caricamento immagine
     */
    widget.find('input[name="widget[file]"]').unbind();
    widget.find('input[name="widget[file]"]').change(function(fileInput) {
      var mime = this.files[0].type;

      if (!this.files && !this.files[0]) {
        return;
      }

      widget
        .find('.ci-widget__result-success')
        .addClass('hide');

      if (mime.substring(0, 6) == 'video/') {

        fileName = fileInput.target.files[0].name;

        widget
          .find('.ci-widget__result-success_file')
          .removeClass('hide');
        widget
          .find('.ci-widget__file-name')
          .text(fileName);

        localStorage.setItem('file_name_' + widgetId, fileName);

      } else {

        var reader = new FileReader();

        fileName = fileInput.target.files[0].name;

        reader.onprogress = function (e) {
          if(reader.readyState == '1') {
            widget
              .find('.ci-widget__result-load_file')
              .removeClass('hide');
          }
        }

        reader.onload = function (e) {
          widget
            .find('.ci-widget__result-load_file')
            .addClass('hide');
          widget
            .find('.ci-widget__result-success_file')
            .removeClass('hide');
          widget
            .find('.ci-widget__file-name')
            .text(fileName);

          localStorage.setItem('image_' + widgetId, e.target.result);
          localStorage.setItem('file_name_' + widgetId, fileName);
        }

        reader.readAsDataURL(this.files[0]);
      }
    });

  },

  /**
   * Initialize add-carousel-item button
   */
  initializeAddMultipleItem: function (widgetId, element, entityName, template, formClass, formName, formField, parentId, parentClass, parentMethod, containerSelector) {
    var widget = $('#ci-widget-' + widgetId);

    element.unbind();
    element.click(function() {

      element.hide();

      $.post('/admin/multipleitem/new', {
        entityName: entityName,
        template: template,
        formClass: formClass,
        formName: formName,
        formField: formField,
        parentId: parentId,
        parentClass: parentClass,
        parentMethod: parentMethod
      }, function (data) {
        widget.find(containerSelector).append(data);
        utl.multipleItemfileReader(widgetId, $('#'+$(data).attr('id')).find('input[type="file"]'));
        utl.initializeRemoveMultipleItem(widgetId, $('#'+$(data).attr('id')).find('.remove-multiple-item'), entityName, $('#'+$(data).attr('id')).attr('data-item'), containerSelector);
        element.show();
      });
    });
  },

  sortMultipleItem: function (widgetId, containerSelector, itemSelector) {
    var widget = $('#ci-widget-' + widgetId);
    // widget[carouselItems][#INDEX#][#FIELDNAME#]
    var fieldnamePattern = widget.find(containerSelector).attr('data-multipleitem-fieldnamepattern');
    var index = 0;
    widget.find(containerSelector + ' ' + itemSelector).each(function (k, v) {

      $(v).find('input,textarea').each(function (k2, v2) {
        //widget[carouselItems][2][sortablePosition]
        var fieldname = $(v2).attr('data-fieldname');
        var newfieldname = fieldnamePattern.replace('#INDEX#', index);
        newfieldname = newfieldname.replace('#FIELDNAME#', fieldname);
        $(v2).attr('name', newfieldname);
        //widget[carouselItems][2]_sortablePosition
        var newfieldid = fieldnamePattern.replace('#INDEX#', index);
        newfieldid = newfieldid.replace('[#FIELDNAME#]', '_'+fieldname);
        $(v2).attr('id', newfieldid);
      });
      $(v).find('.sortable-position').val(index);
      index = index + 1;
    });
  },

  initializeRemoveMultipleItem: function (widgetId, element, entityName, entityId, containerSelector) {
    var widget = $('#ci-widget-' + widgetId);
    element.unbind();
    element.click(function() {
      //if (confirm('Sei sicuro di voler eliminare questo elemento?')) {
      var addButton = widget.find(containerSelector+'__container').find('.add-multiple-item');
      //console.log(containerSelector+'-container');
      //console.log(addButton);
      addButton.hide();
      $.post('/admin/multipleitem/delete', {
        entityName: entityName,
        entityId: entityId
      }, function (entityId) {
        widget.find(containerSelector).find('#carousel-item-'+entityId).remove();
        utl.sortMultipleItem(widgetId, containerSelector, element.attr('data-itemselector'));
        //console.log(addButton);
        addButton.show();
      });
      //}
    });
  },

  multipleItemfileReader: function(widgetId, element) {
    var widget = $('#ci-widget-' + widgetId);
    var row = element.parentsUntil('tr').parent();
    var image = row.find('img[data-type="image"]');

    /**
     * Change sul file input del caricamento immagine
     */
    row.find('input[type="file"]').unbind();
    row.find('input[type="file"]').change(function(fileInput) {

      var files = fileInput.target.files;

      var mime = files[0].type;

      if (!files && !files[0]) {
        return;
      }

      row
        .find('.ci-widget__result-success-multiple-item')
        .addClass('hide');

      if (mime.substring(0, 6) == 'video/') {

        fileName = files[0].name;

        row
          .find('.ci-widget__result-success-multiple-item_file')
          .removeClass('hide');
        row
          .find('.ci-widget__file-name-multiple-item')
          .text(fileName);

      } else {

        var reader = new FileReader();

        fileName = files[0].name;

        reader.onprogress = function (e) {
          if(reader.readyState == '1') {
            row
              .find('.ci-widget__result-load-multiple-item_file')
              .removeClass('hide');
          }
        }

        reader.onload = function (e) {
          row
            .find('.ci-widget__result-load-multiple-item_file')
            .addClass('hide');
          row
            .find('.ci-widget__result-success-multiple-item_file')
            .removeClass('hide');
          row
            .find('.ci-widget__file-name-multiple-item')
            .text(fileName);

          row.find('.ci-widget__preview_file-multiple-item').attr('src', e.target.result);
        }

        reader.readAsDataURL(files[0]);
      }
    });

  },

  getMonthName: function(text) {
    var monthNames = [
      'gennaio', 'febbraio', 'marzo',
      'aprile', 'maggio', 'giugno',
      'luglio', 'agosto', 'settembre',
      'ottobre', 'novembre', 'dicembre'
    ];

    return monthNames[text.getMonth()]
  },

  initBlock: function(blockType, widgetType) {
    $('.draggable__item[data-widget-type="' + widgetType + '"]')
      .clone()
      .appendTo('.ci-block_type_' + blockType + ' .sortable');

    var draggableWidget = $('.ci-block_type_' + blockType + ' .draggable__item[data-widget-type="' + widgetType + '"]');
    var card            = draggableWidget.find('.ci-card');
    var widget          = card.find('.ci-widget');
    var template        = widget.closest('.ci-block').data('template');

    widget.find('input[name="widget[block]"]').val(blockType);
    widget.find('input[name="widget[template]"]').val(template);

    draggableWidget
      .removeClass('ui-sortable-handle draggable__item_first')
      .addClass('ui-draggable ui-draggable-handle ui-resizable draggable__item_block_' + blockType);

    if (widgetType == 'widgetslug') {
      draggableWidget.addClass('hide');
    }

    wdg.initWidget(draggableWidget);
    wdg.createWidget(card, widget);
  },

  orderWidget: function(widgets, widgetsGroups, widgetsOrdered) {
    if (typeof widgetsOrdered == 'undefined') {
      var widgetsOrdered = [];
    }

    widgetsGroups.forEach(function(element, i) {
      if (Array.isArray(element)) {
        widgetsOrdered.push([]);
        widgetsOrdered[i] = utl.orderWidget(widgets, widgetsGroups[i], widgetsOrdered[i]);
      } else {
        Object.keys(widgets).forEach(function(key) {
          if (widgets[key].dataset.widgetType == element) {
            widgetsOrdered.push(widgets[key]);
          }
        });
      }
    });

    return widgetsOrdered;
  },

  slugify: function(text) {

    return text.toString().toLowerCase()
      .replace(/\s+/g, '-')           // Replace spaces with -
      .replace(/\-\-+/g, '-')         // Replace multiple - with single -
      .replace(/^-+/, '')             // Trim - from start of text
      .replace(/-+$/, '');            // Trim - from end of text
  },

  validateEmail: function(email) {
    var re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

    return re.test(email);
  },

  uniqueId: function(prefix) {
    return prefix+'_' + Math.random().toString(36).substr(2, 9);
  },
  trackAPIConversion: function (label, eventID, fbp, fbc, timestamp) {
    $.get('/pixel-api-conversion/ajax.php', {
      'event_name': label,
      'event_id': eventID,
      'fbq': fbp,
      'fbc': fbc,
      'timestamp': timestamp
    }, function (data) {
      // console.log(data);
    });
  },
  fbq_track: function(label, counter) {
    if (label) {
      var now = Math.floor(Date.now() / 1000);
      var eventID = utl.uniqueId(now);
      if (typeof fbq == 'function') {
        fbq('track', label, {}, {eventID: eventID});
        utl.trackAPIConversion(label, eventID, cookieManager.getCookie('_fbp'), cookieManager.getCookie('_fbc'), now);
      }
    }
  },
  fbq_trackCustom: function(label) {
    if (label) {
      var now = Math.floor(Date.now() / 1000);
      var eventID = utl.uniqueId(now);
      if (typeof fbq == 'function') {
        fbq('trackCustom', label, {}, {eventID: eventID});
        utl.trackAPIConversion(label, eventID, cookieManager.getCookie('_fbp'), cookieManager.getCookie('_fbc'), now);
      }
    }
  }
}
